export default "__VITE_ASSET__DoTqpE8Z__"